import React, { Component } from 'react';
import ProgressBar from '../../artzu-ui/src/ProgressBar';
import Divider from '../../artzu-ui/src/Divider';
import Header from './Header';

class ProgressHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getTitle() {
    return this.steps()[this.props.currentStep];
  }

  render() {
    const {
      currentStep,
      decrementStep,
      goToSaved,
      uberTerms,
      title,
      history
    } = this.props;
    return (
      <div
        className="apply__header"
        style={
          history.location.pathname.includes('Mobile')
            ? { top: '0' }
            : null
        }>
        <div className="apply__header--container container">
          <div className="apply__header--content">
            <Header
              disable={currentStep === 5}
              back={currentStep === 0 && uberTerms}
              onClick={decrementStep}
              goToSaved={goToSaved}
              title={title}
              step={currentStep}
            />
            <div className="apply__header--progress-bar-container">
              <ProgressBar
                className="apply__header--progress-bar"
                fillers={[((currentStep + 1) / 6) * 100]}
              />
            </div>
            {currentStep === 5 ? null : /applyMobile/.test(
                window.location.href
              ) ? (
              <a href="/dashboard">
                <div className="apply__header--save"> Save </div>
              </a>
            ) : currentStep === 0 ? null : (
              <div
                className="apply__header--save"
                onClick={() => goToSaved()}>
                {' '}
                Save{' '}
              </div>
            )}
          </div>
          <Divider />
        </div>
      </div>
    );
  }
}

export default ProgressHeader;



// WEBPACK FOOTER //
// ./src/components/TorontoApply/ProgressHeader.js